<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            id="planoBimestral.voltar"
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'gestoesDeAulas',
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Plano Bimestral Interdisciplinar
        </h1>
      </v-col>
    </v-row>
    <div v-if="turmaSemCircuito">
      <v-alert
        type="warning"
        border="left"
        colored-border
        elevation="2"
        icon="mdi-alert-circle-outline"
        dense
        class="mt-4"
      >
        Não é possível enviar planos bimestrais: não há circuito cadastrado para esta turma.
      </v-alert>
    </div>
    <div v-else>
      <v-row>
        <v-col cols="12" v-if="gestaoDeAula">
          <v-card color="green lighten-1" outlined>
            <v-col cols="8">
              <v-card-text>
                <h4 class="mb-2">Turma: {{ gestaoDeAula.turma?.descricao }}</h4>
                <h4 class="mb-2">
                  Disciplinas:
                  <v-chip
                    v-for="(disc, index) in disciplinasPermitidas"
                    :key="index"
                    small
                    class="ma-1"
                    color="teal darken-2"
                    text-color="white"
                  >
                    {{ disc.descricao }}
                  </v-chip>
                </h4>
                <h4 class="mb-2">
                  Professor:
                  {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[carregando...]" }}
                </h4>
              </v-card-text>
            </v-col>
          </v-card>
        </v-col>

        <v-col cols="12 text-center" class="pt-2">
          <template>
            <v-toolbar>
              <v-tabs dark background-color="primary" v-model="indexTabEtapas" grow>
                <v-tab
                  v-for="(value, desc) in etapas"
                  :key="parseInt(value, 10)"
                  @click="() => loadData(parseInt(value, 10))"
                >
                  <v-badge v-if="form.etapa_id === parseInt(value, 10)" color="success">
                    {{ desc }}
                  </v-badge>
                  <div v-else>{{ desc }}</div>
                </v-tab>
              </v-tabs>
            </v-toolbar>
          </template>
        </v-col>
      </v-row>

      <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
        <form
          @submit.prevent="handleSubmit(createOrUpdate)"
          v-if="loadPlano"
          :disabled="submittingForm"
        >
          <v-row>
            <v-col cols="12" class="mt-4">
              <v-expansion-panels v-model="painelAberto" multiple>
                <v-expansion-panel
                  v-for="disciplinaForm in form.disciplinas"
                  :key="disciplinaForm.disciplina_id"
                >
                  <v-expansion-panel-header color="green lighten-4">
                    <strong>{{ getNomeDisciplina(disciplinaForm.disciplina_id) }}</strong>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="mt-2">
                      <v-col cols="12" v-if="!isDisciplinaEspecial(disciplinaForm.disciplina_id)">
                        <e-label>UNIDADES TEMÁTICAS</e-label>
                        <div class="d-flex flex-wrap">
                          <template v-if="getUnidadesTematicas(disciplinaForm).length">
                            <v-chip
                              v-for="(item, i) in getUnidadesTematicas(disciplinaForm)"
                              :key="i"
                              label
                              large
                              color="secondary"
                              class="ma-1 chip-wrap"
                            >
                              {{ item }}
                            </v-chip>
                          </template>
                          <template v-else>
                            <v-chip
                              label
                              large
                              class="ma-1"
                              color="grey lighten-2"
                              text-color="black"
                            >
                              Selecione pelo menos uma habilidade para exibir as unidades temáticas
                            </v-chip>
                          </template>
                        </div>
                      </v-col>

                      <v-col cols="12" v-if="!isDisciplinaEspecial(disciplinaForm.disciplina_id)">
                        <e-label>OBJETOS DO CONHECIMENTO</e-label>
                        <div class="d-flex flex-wrap">
                          <template v-if="getObjetosConhecimento(disciplinaForm).length">
                            <v-chip
                              v-for="(obj, i) in getObjetosConhecimento(disciplinaForm)"
                              :key="i"
                              label
                              large
                              color="primary"
                              class="ma-1 descricao-wrap"
                            >
                              {{ obj }}
                            </v-chip>
                          </template>
                          <template v-else>
                            <v-chip
                              label
                              large
                              class="ma-1"
                              color="grey lighten-2"
                              text-color="black"
                            >
                              Selecione pelo menos uma habilidade para exibir os objetos do
                              conhecimento
                            </v-chip>
                          </template>
                        </div>
                      </v-col>

                      <v-col cols="12" v-if="!isDisciplinaEspecial(disciplinaForm.disciplina_id)">
                        <ValidationProvider
                          :name="`Habilidades - ${getNomeDisciplina(disciplinaForm.disciplina_id)}`"
                          :rules="isDisciplinaBncc(disciplinaForm.disciplina_id) ? 'required' : ''"
                          v-slot="{ errors }"
                        >
                          <e-label>HABILIDADES</e-label>
                          <v-chip
                            label
                            x-small
                            class="ml-2"
                            color="green lighten-4"
                            v-if="!isDisciplinaBncc(disciplinaForm.disciplina_id)"
                            >Não obrigatório</v-chip
                          >
                          <v-autocomplete
                            :id="`planoBimestral.habilidades-${disciplinaForm.disciplina_id}`"
                            v-model="disciplinaForm.habilidades"
                            :items="getHabilidadesBncc(disciplinaForm.disciplina_id)"
                            item-text="descricao"
                            item-value="id"
                            multiple
                            chips
                            clearable
                            solo
                            dense
                            return-object
                            :error-messages="errors"
                            menu-props="max-height: 100"
                            style="max-height: 320px; overflow-y: auto; padding-right: 8px"
                            :filter="habilidadesSiglasFilter"
                            no-data-text="Nenhuma habilidade encontrada para essa disciplina"
                          >
                            <template v-slot:item="data">
                              <div class="d-flex flex-column align-start pa-4 w-100">
                                <v-chip small class="mb-1" color="primary" text-color="white">
                                  {{ data.item.apelido }}
                                </v-chip>
                                <span class="descricao-wrap">{{ data.item.descricao }}</span>
                                <v-divider class="mx-4" />
                              </div>
                            </template>
                            <template v-slot:selection="data">
                              <v-row align="center" class="ma-4">
                                <v-col cols="auto">
                                  <v-chip
                                    color="grey lighten-2"
                                    small
                                    class="mr-2"
                                    text-color="black"
                                  >
                                    {{ data.item.apelido }}
                                  </v-chip>
                                </v-col>
                                <v-col cols="auto">
                                  <span class="descricao-wrap">{{ data.item.descricao }}</span>
                                </v-col>
                              </v-row>
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                      </v-col>

                      <template v-if="isDisciplinaEspecial(disciplinaForm.disciplina_id)">
                        <v-col cols="12">
                          <ValidationProvider
                            :name="`Unidades Temáticas - ${getNomeDisciplina(
                              disciplinaForm.disciplina_id
                            )}`"
                            v-slot="{ errors }"
                          >
                            <e-label>UNIDADES TEMÁTICAS</e-label>
                            <v-textarea
                              solo
                              dense
                              v-model="disciplinaForm.unidades_tematicas_especial"
                              :error-messages="errors"
                            />
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12">
                          <ValidationProvider
                            :name="`Objetos do Conhecimento - ${getNomeDisciplina(
                              disciplinaForm.disciplina_id
                            )}`"
                            v-slot="{ errors }"
                          >
                            <e-label>OBJETOS DO CONHECIMENTO</e-label>
                            <v-textarea
                              solo
                              dense
                              v-model="disciplinaForm.objetos_conhecimento_especial"
                              :error-messages="errors"
                            />
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12">
                          <ValidationProvider
                            :name="`Habilidades - ${getNomeDisciplina(
                              disciplinaForm.disciplina_id
                            )}`"
                            v-slot="{ errors }"
                          >
                            <e-label>HABILIDADES</e-label>
                            <v-textarea
                              solo
                              dense
                              v-model="disciplinaForm.habilidades_especial"
                              :error-messages="errors"
                            />
                          </ValidationProvider>
                        </v-col>
                      </template>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>

            <v-col cols="12">
              <ValidationProvider name="Metodologia" rules="required" v-slot="{ errors }">
                <e-label>PROCEDIMENTO METODOLÓGICO</e-label>
                <v-textarea solo dense v-model="form.metodologia" :error-messages="errors" />
              </ValidationProvider>
            </v-col>

            <v-col cols="12">
              <ValidationProvider
                name="Avaliação da aprendizagem"
                rules="required"
                v-slot="{ errors }"
              >
                <e-label>AVALIAÇÃO</e-label>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-for="(item, index) in $constants.planoBimestralAvalicao"
                    :key="index"
                  >
                    <v-checkbox
                      :label="item.label"
                      :value="item.label"
                      v-model="form.avaliacao_aprendizagem"
                      multiple
                      :error-messages="errors"
                    />
                  </v-col>
                </v-row>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-col cols="12" class="mt-6">
            <v-row>
              <v-btn
                id="planoBimestral.submit"
                color="primary"
                :disabled="submittingForm"
                :loading="submittingForm"
                type="submit"
                >Enviar Dados</v-btn
              >
            </v-row>
          </v-col>
        </form>
      </ValidationObserver>
    </div>
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },

  async mounted() {
    await this.loadData();
  },

  data() {
    return {
      submittingForm: false,
      form: {
        etapa_id: null,
        metodologia: "",
        avaliacao_aprendizagem: [],
        disciplinas: [],
      },
      gestaoDeAula: {
        turma: { descricao: "" },
        disciplinas: [],
      },
      loadPlano: true,
      etapas: [],
      indexTabEtapas: null,
      painelAberto: [],
      // mapa: disciplina_id -> { habilidades_bncc, habilidades_saeb }
      habilidadesPorDisciplina: {},
      disciplinasPermitidas: [],
    };
  },

  computed: {
    turmaSemCircuito() {
      return this.etapas.length === 0;
    },
  },

  methods: {
    getNomeDisciplina(disciplinaId) {
      const disc = this.gestaoDeAula.disciplinas.find((d) => d.id === disciplinaId);
      return disc ? disc.descricao : `Disciplina ${disciplinaId}`;
    },

    isDisciplinaBncc(disciplinaId) {
      const disc = this.gestaoDeAula.disciplinas.find((d) => d.id === disciplinaId);
      return disc ? !!disc.is_bncc : false;
    },

    isDisciplinaEspecial(disciplinaId) {
      const disc = this.gestaoDeAula.disciplinas.find((d) => d.id === disciplinaId);
      return disc ? !!disc.is_especial : false;
    },

    getHabilidadesBncc(disciplinaId) {
      return this.habilidadesPorDisciplina[disciplinaId]?.habilidades_bncc || [];
    },

    getHabilidadesSaeb(disciplinaId) {
      return this.habilidadesPorDisciplina[disciplinaId]?.habilidades_saeb || [];
    },

    getUnidadesTematicas(disciplinaForm) {
      const todas = disciplinaForm.habilidades
        ?.map((h) => h.unidades_tematicas || h.praticas_linguagem)
        .filter(Boolean);
      return [...new Set(todas)];
    },

    getObjetosConhecimento(disciplinaForm) {
      const todos = disciplinaForm.habilidades?.map((h) => h.objeto_conhecimento).filter(Boolean);
      return [...new Set(todos)];
    },

    getSaebItemById(disciplinaId, id) {
      return this.getHabilidadesSaeb(disciplinaId).find((item) => item.id === id) || {};
    },

    habilidadesSiglasFilter(item, queryText) {
      const text = `${item.descricao} ${item.apelido}`.toLowerCase();
      return text.includes(queryText.toLowerCase());
    },

    formatCode(item) {
      try {
        const numero = parseInt(item.sequencia.split(".")[0], 10);
        return `${item.prefixo}${String(numero)}`;
      } catch {
        return (item.prefixo || "") + (item.sequencia || "");
      }
    },

    customFilter(item, queryText) {
      const codigo = this.formatCode(item);
      const descricao = item.descricao?.toLowerCase() || "";
      return (
        codigo.toLowerCase().includes(queryText.toLowerCase()) ||
        descricao.includes(queryText.toLowerCase())
      );
    },

    async loadData(etapa_id) {
      if (this.$refs.observer) {
        await this.$refs.observer.reset();
      }
      this.submittingForm = false;
      const { gestaoDeAulaId } = this.$route.params;

      try {
        this.$loaderService.open("Carregando dados...");

        if (!etapa_id) {
          this.gestaoDeAula = await this.$services.gestoesDeAulasService.visualizarTurmaGestao(
            gestaoDeAulaId
          );
          this.form.etapa_id = this.gestaoDeAula.turma.circuito?.etapas[0].id;
        }

        const response =
          await this.$services.planosBimestraisService.planoBimestralInterdisciplinar(
            gestaoDeAulaId,
            etapa_id || this.form.etapa_id
          );

        if (etapa_id) {
          this.form.etapa_id = etapa_id;
        }

        this.etapas = response.etapas ?? [];
        this.habilidadesPorDisciplina = response.disciplinas ?? {};
        this.disciplinasPermitidas = Object.values(response.disciplinas ?? {}).map(
          (d) => d.disciplina
        );

        if (response.plano) {
          this.form = {
            ...this.form,
            metodologia: response.plano.metodologia || "",
            avaliacao_aprendizagem: response.plano.avaliacao_aprendizagem
              ? JSON.parse(response.plano.avaliacao_aprendizagem)
              : [],
            disciplinas: response.plano.disciplinas || this.buildDisciplinasVazias(),
          };
        } else {
          this.form.disciplinas = this.buildDisciplinasVazias();
          this.form.metodologia = "";
          this.form.avaliacao_aprendizagem = [];
        }

        // abrir todos os paineis por padrão
        this.painelAberto = this.form.disciplinas.map((_, i) => i);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    buildDisciplinasVazias() {
      return this.disciplinasPermitidas.map((disc) => ({
        disciplina_id: disc.id,
        habilidades: [],
        descritores: [],
        unidades_tematicas_especial: "",
        objetos_conhecimento_especial: "",
        habilidades_especial: "",
      }));
    },

    async createOrUpdate() {
      this.$loaderService.open("Salvando...");
      try {
        const { gestaoDeAulaId } = this.$route.params;
        this.form.instrutorDisciplinaTurma_id = gestaoDeAulaId;
        await this.$services.planosBimestraisService.createOrUpdateInterdisciplinar(this.form);
        this.$toast.success("Plano bimestral interdisciplinar salvo com sucesso!");
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style>
.descricao-wrap {
  white-space: normal;
  word-break: break-word;
}
.chip-wrap {
  white-space: normal;
  word-break: break-word;
}
</style>
